<template>
    <div class="population-view">
        <PopulationList
            :patient-list="patientList"
            :list-title="listTitle"
            :url="url"></PopulationList>
        <div class="detail">
            <router-view
                v-bind:url="url"
                v-bind:print="null">
                </router-view>
            </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'

import PopulationList from '@/module/population/list/List'

export default {
    name: 'tag-population',

    props: {
        tag: {
            type: String,
            required: true
        }
    },

    watch: {
        topic: {
            immediate: true,
            handler(val) {
                this.loadPatientTickets()
            }
        }
    },

    mounted() {
        this.loadPatients()
    },

    methods: {
        ...mapActions('provider', [
            'loadPatients',
            'loadPatientTickets',
        ]),
    },


    computed: {
        ...mapState('provider', {
            tickets: state => state.tickets,
            ticketsConfig: state => state.ticketsConfig,
            providerPatients: state => state.providerPatients
        }),
        ...mapGetters('provider', [
            'getCurrentProvider',
            'getAllProviderPatientList'
        ]),
        url() {
            return '/tag/' + this.tag
        },
        listTitle() {
            const topic = this.ticketsConfig.find((config) => config.id === this.topic)
            if(topic)
                return topic.title
            return ''
        },
        patientList() {
            if(this.tag) {
                let patientList = this.getAllProviderPatientList.filter((patient) => patient.tag)
                if(this.getCurrentProvider) {
                    let patientProvider =  this.providerPatients.find((provider) => provider.id === this.getCurrentProvider)
                    if(patientProvider)
                        patientList = patientProvider ? patientProvider.patient : []
                }
                patientList = patientList.filter(({ tag }) => tag)
                        .filter(({ tag }) => {
                            return tag.filter(t => t.id === this.tag).length
                        })
                return patientList.map(({ id }) => id)
            }
            return []
        }
    },

    components: {
        PopulationList
    }
}
</script>

<style>
.list {
	width: 240px;
	height: 100%;
	overflow-y: auto;
	float: left;
	border-right: solid 1px #dfdfdf;
}
.detail {
	height: 100%;
	overflow-y: auto;
}
.filter-view {
    padding: 10px;
    background: #fafafa;

    .el-card {
        margin-bottom: 10px;
    }
}
</style>
